export { default as QuickConfigs } from './quick-configs';
